import { getAllConstants } from "./action";

const getAllConstantsAction = () => getAllConstants();


export default {
    getAllConstantsAction,

}
